import React from "react";
import { PropertyEditorTextList, PropertyEditorTextListInterface } from "../PropertyEditorTextList";
import { StateManager } from "../../../rule-engine-core/Common/StateManager";
import { StoryNode } from "../../StoryBook/StoryData";
import { IDesignValidationProvider, ValidationIssue } from "../../../rule-engine-core/Common/IDesignValidationProvider";

class TextListData implements PropertyEditorTextListInterface {
    editObject: object = {};
    label: string = "TextEditor";
    propertyName: string = "textList";
    hint: string = "Please input multiline text";
}

class TextListData2 implements PropertyEditorTextListInterface {
    editObject: IDesignValidationProvider = {
        getDesignValidationIssues(): ValidationIssue[] {
            return [new ValidationIssue("issue", "textList"), new ValidationIssue("issue2", "textList")];
        },
    };
    label: string = "TextEditor";
    propertyName: string = "textList";
    hint: string = "Please input multiline text";
}

export const TextListPropertyEditor = [
    new StoryNode(
        (logCallback) => {
            let args = new TextListData();
            return (
                <PropertyEditorTextList
                    onChange={() => {
                        StateManager.propertyChanged(args.editObject, args.propertyName);
                        let ar = Reflect.get(args.editObject, args.propertyName) as string[];
                        logCallback(ar.join(","));
                    }}
                    {...args}
                />
            );
        },
        "Shared",
        "Property Editors",
        "Text List",
        "Default",
    ),

    new StoryNode(
        (logCallback) => {
            let args = new TextListData();
            return (
                <PropertyEditorTextList
                    onChange={() => {
                        StateManager.propertyChanged(args.editObject, args.propertyName);
                        let ar = Reflect.get(args.editObject, args.propertyName) as string[];
                        logCallback(ar.join(","));
                    }}
                    validValues={["a", "b", "c"]}
                    {...args}
                />
            );
        },
        "Shared",
        "Property Editors",
        "Text List",
        "Valid Values",
    ),

    new StoryNode(
        (logCallback) => {
            let args = new TextListData();
            return (
                <PropertyEditorTextList
                    onChange={() => {
                        StateManager.propertyChanged(args.editObject, args.propertyName);
                        let ar = Reflect.get(args.editObject, args.propertyName) as string[];
                        logCallback(ar.join(","));
                    }}
                    error={"Error Text"}
                    {...args}
                />
            );
        },
        "Shared",
        "Property Editors",
        "Text List",
        "Default - Error",
    ),

    new StoryNode(
        (logCallback) => {
            let args = new TextListData();
            return (
                <PropertyEditorTextList
                    onChange={() => {
                        StateManager.propertyChanged(args.editObject, args.propertyName);
                        let ar = Reflect.get(args.editObject, args.propertyName) as string[];
                        logCallback(ar.join(","));
                    }}
                    error={"Error Text"}
                    validValues={["a", "b", "c"]}
                    {...args}
                />
            );
        },
        "Shared",
        "Property Editors",
        "Text List",
        "Valid Values - Error",
    ),
    new StoryNode(
        (logCallback) => {
            let args = new TextListData2();
            return (
                <PropertyEditorTextList
                    onChange={() => {
                        StateManager.propertyChanged(args.editObject, args.propertyName);
                        let ar = Reflect.get(args.editObject, args.propertyName) as string[];
                        logCallback(ar.join(","));
                    }}
                    {...args}
                />
            );
        },
        "Shared",
        "Property Editors",
        "Text List",
        "Default - Validation Provider",
    ),

    new StoryNode(
        (logCallback) => {
            let args = new TextListData2();
            return (
                <PropertyEditorTextList
                    onChange={() => {
                        StateManager.propertyChanged(args.editObject, args.propertyName);
                        let ar = Reflect.get(args.editObject, args.propertyName) as string[];
                        logCallback(ar.join(","));
                    }}
                    validValues={["a", "b", "c"]}
                    {...args}
                />
            );
        },
        "Shared",
        "Property Editors",
        "Text List",
        "Valid Values - Validation Provider",
    ),
];
